<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.7928 19.3711L15.207 17.9569L9.24747 11.9973L15.207 6.03776L13.7928 4.62355L6.41904 11.9973L13.7928 19.3711Z"
    fill="white"
  />
</svg>
